import { AloftPrice } from '@aloft/toolkit-shared';

import { selectDepreciation } from '../../../../redux/features/selectors/depreciationSelectors.ts';
import { selectCostNewDisplay } from '../../../../redux/features/selectors/selectCostNew.ts';
import { selectDepreciatedCostOfImprovementsDisplay } from '../../../../redux/features/selectors/selectDepreciatedCostOfImprovements.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';

export const useDepreciatedCostCalculationString = (id: string): string => {
  const costNew = useAppSelector((state) => selectCostNewDisplay(state, id)) ?? '$0';
  const depreciation = (useAppSelector((state) => selectDepreciation(state, id)) ?? AloftPrice.zero)
    .abs()
    .toString(true);
  const depreciatedCost =
    useAppSelector((state) => selectDepreciatedCostOfImprovementsDisplay(state, id)) ?? '$0';

  return `${costNew} - ${depreciation} = ${depreciatedCost}`;
};
